var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 133,
    height: 126,
    viewBox: "0 0 133 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0651 125.845C97.895 125.845 126.13 97.6737 126.13 62.9225C126.13 28.1714 97.895 0 63.0651 0C28.2352 0 0 28.1714 0 62.9225C0 97.6737 28.2352 125.845 63.0651 125.845Z",
    fill: "#242D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133 102.808H23V37.7393H133V102.808Z",
    fill: "#415360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 37.7393H133V102.808H78V37.7393Z",
    fill: "#333F48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6328 14H53.0781V38.0367H46.6328V14Z",
    fill: "current",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.922 14H109.367V38.0367H102.922V14Z",
    fill: "current",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8914 78.3325V84.1019H40.5093V59.1089H57.5747V64.8783H46.9438V68.6131H56.0257V74.175H46.9438V78.3325H57.8914Z",
    fill: "#E6E8EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6317 59.1089L71.1727 66.9941L75.7138 59.1089H83.106L74.7634 71.7814L82.8245 84.1019H75.4324L71.1729 76.5688L66.9136 84.1019H59.4862L67.5474 71.7814L59.2046 59.1089H66.6317Z",
    fill: "#E6E8EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.106 59.1089H78V66.865L83.106 59.1089Z",
    fill: "#D5E8FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78 76.7283V84.1019H82.8245L78 76.7283Z",
    fill: "#D5E8FE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8662 84.1019V59.1089H91.7303V84.1019H84.8662Z",
    fill: "#D5E8FE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M115.491 65.0931H108.185V84.1019H101.535V65.0931H94.2295V59.1089H115.491L115.491 65.0931Z",
    fill: "#D5E8FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8556 45.1005C53.7569 45.1005 56.9196 41.9378 56.9196 38.0365C56.9196 34.1351 53.7569 30.9724 49.8556 30.9724C45.9542 30.9724 42.7915 34.1351 42.7915 38.0365C42.7915 41.9378 45.9542 45.1005 49.8556 45.1005Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.145 45.1005C110.046 45.1005 113.209 41.9378 113.209 38.0365C113.209 34.1351 110.046 30.9724 106.145 30.9724C102.243 30.9724 99.0806 34.1351 99.0806 38.0365C99.0806 41.9378 102.243 45.1005 106.145 45.1005Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.5ec8c51f4bb66666835657498038c053.svg";
export { ForwardRef as ReactComponent };